import {Component, isDevMode, OnDestroy, OnInit} from '@angular/core';
import {environment} from "../../../../environments/environment";
import {Observable, Subscription} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {UserRole} from "../../rename/add-user-role/add-user-role.component";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {AngularFireDatabase} from "@angular/fire/compat/database";
import _default from "chart.js/dist/plugins/plugin.legend";
import title = _default.defaults.title;
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {AddRolePermissionsComponent} from "../add-role-permissions/add-role-permissions.component";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {PERMISSIONS} from "../permissions.model";
import {Subject} from "rxjs/internal/Subject";
import {takeUntil} from "rxjs/internal/operators/takeUntil";

@Component({
  selector: 'app-edit-rol-permissions',
  templateUrl: './edit-role-permissions.component.html',
  styleUrls: ['./edit-role-permissions.component.scss']
})
export class EditRolePermissionsComponent implements OnInit,OnDestroy {
  env = isDevMode() ? environment.testMode : environment.productionMode;
  defaultPermissions = [
    'Child Admission',
    'Child Prescreening',
    'Counselling',

    'Education',
    'Meal Mate',
    'Unit Sponsorship',
    'General Donation',
    'CMS',
    'Education Report',
    'Donation Report',
    'Weekly Report',
    'Hospital',
    'Unit',
    'Types',
    'Donor',
    'Event',
    'Audit Logs',
    'Inventory',
    'Vehicles',
    // Add other function names as needed
    'Audit Logs',
    'Dashboard',
    'Child Admission',
    'Donation Report',
    'Child Report',
    'Unit Sponsorship',
    'Centres',
    'Employees',
    'Tasks',
    'Ops Reports',
    'Counseling Report'
  ];
  permissionsMap: { [key: string]: UserRole[] } = {};

  permissionsData: UserRole[] = []
  data: UserRole[] = []
  roleSelected: any;
  roles$: Observable<any[]>;
  selectedRole: string | undefined;
  private destroy$ = new Subject<void>();

  constructor(private firestore: AngularFirestore,
              private fb: FormBuilder,
              private dialog: MatDialog,
              private http: HttpClient) {
    this.roles$ = this.firestore.collection<any>(this.env.userPermissions).valueChanges({idField: 'id'}).pipe(
      takeUntil(this.destroy$)
    )

    this.roles$.subscribe(res => {
      console.log(res.length)
      // console.log(this.roles$)
    })
    // this.roles$ = this.mDatabase.list('types/Employee Roles').valueChanges()
  }

  ngOnInit(): void {


// this.createAllRoles()




  }
  createAllRoles() {
    const roles = [
      // 'CEO',
      // 'Centre Coordinator',
      // 'Centre Manager',
      // 'Counsellor',
      // 'Default Permissions',
      // 'Deputy General Manager',
      // 'Donor',
      // 'General Manager - Operations',
      // 'Program Manager',
      // 'Sr Counsellor',
      // 'Sr Teacher',
      'Teachers'
    ];

    roles.forEach(role => {
      this.loadAndSavePermissions(role);
    });
  }

  private loadAndSavePermissions(ROLE:string) {
alert(ROLE)
    // const PERMISSIONS = PERMISSIONS.filter(
    //   permission => permission.role === ROLE
    //
    if (PERMISSIONS && PERMISSIONS.length > 0) {
      const batch = this.firestore.firestore.batch();
      const permissionsRef = this.firestore.collection(this.env.userPermissions).doc(ROLE).collection('permissions');
      const roleRef = this.firestore.collection(this.env.userPermissions).doc(ROLE)
      PERMISSIONS.forEach(permission => {
        // Remove any potential undefined/null permissions
        if (permission) {
          console.log(permission.functionName)
          // Clean up the permission object to match UserRole interface
          const cleanPermission: UserRole = {
            functionName: permission.functionName,
            group: permission.group,
            all: permission.all||false,
            add: permission.add||false,
            edit: permission.edit||false,
            archive: permission.archive||false,
            view: permission.view||false,
            excel: permission.excel||false,
            showMenu: permission.showMenu||false
          };
          console.log(cleanPermission)
          const docRef = permissionsRef.doc().ref;
          batch.set(docRef, cleanPermission);
          batch.set(roleRef.ref, {createdAt: new Date(), updatedAt: new Date()}, {merge: true});
        }
      });

      batch.commit().then(() => {
        console.log('Permissions successfully loaded and saved');
      }).catch(error => {
        console.error('Error saving permissions:', error);
      });
    } else {
      console.error('No permissions found in PERMISSIONS constant');
    }
  }


  onRoleSelect(event: any) {
    this.featchPermmisions(event.value)
  }


  private featchPermmisions(value: string) {
    this.selectedRole = value
    this.firestore.collection<UserRole>(`/${this.env.userPermissions}/${value}/permissions`, ref => ref.orderBy('functionName', 'asc')).valueChanges({idField: 'id'}).pipe(takeUntil(this.destroy$)).subscribe(res => {
      this.permissionsData = res
      this.permissionsData.sort((a, b) => {
        const groupA = a.group || ''; // Treat null as an empty string
        const groupB = b.group || ''; // Treat null as an empty string
        return groupA.localeCompare(groupB);
      });
      console.log(res)
    })
  }

  // selectionChangeRoleCheckBox(checked:any, id:any,type:string){
  //   // this.firestore.doc(`/user_permissions/${add}/permission/${id}`).set({[type]:add}, { merge: true })
  //   this.firestore.doc(`/${this.env.userPermissions}/${this.selectedRole}/permissions/${id}`).set({[type]:checked}, { merge: true })
  //     .then(() => {
  //       console.log('Permissions updated successfully!');
  //       console.log(`Path: /user_permissions/${this.selectedRole}/permissions/${id}`);
  //       console.log(`Type: ${type}, ${type}: ${checked}`);
  //     })
  //     .catch((error) => {
  //       console.error('Error updating permissions: ', error);
  //     });
  // }
  selectionChangeRoleCheckBox(checked: boolean, id: any, type: string) {
    const permission = this.permissionsData.find(p => p.id === id);
    if (!permission) return;

    if (type === 'all') {
      // If "All" is checked, set all other permissions to true
      permission.add = checked;
      permission.edit = checked;
      permission.archive = checked;
      permission.view = checked;
      permission.excel = checked;
      permission.showMenu = checked;
    } else {
      // If any individual checkbox is unchecked, uncheck "All"
      if (!checked) {
        permission.all = false;
      } else {
        // If all permissions are checked, "All" should be checked
        if (
          permission.add &&
          permission.edit &&
          permission.archive &&
          permission.view &&
          permission.excel &&
          permission.showMenu
        ) {
          permission.all = true;
        }
      }
    }

    // Update Firestore with all changes
    this.firestore.doc(`/${this.env.userPermissions}/${this.selectedRole}/permissions/${id}`)
      .set({...permission}, {merge: true})
      .then(() => console.log('Permissions updated successfully!'))
      .catch(error => console.error('Error updating permissions:', error));

  }


  /** rows that belong to the given group header */
  private groupRows(group: string | undefined): UserRole[] {
    const g = group || '';
    return this.permissionsData.filter(p => (p.group || '') === g);
  }

  /** header checkbox is ticked only when every row in the group has that flag on */
  isGroupColumnChecked(group: string | undefined, field: keyof UserRole): boolean {
    const rows = this.groupRows(group);
    return rows.length > 0 && rows.every(r => !!r[field]);
  }

  /** tick/untick a whole column for a group and persist each row */
  toggleGroupColumn(group: string | undefined, field: 'all' | 'add' | 'edit' | 'archive' | 'view' | 'excel' | 'showMenu', event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    const rows = this.groupRows(group);

    rows.forEach(r => {
      if (field === 'all') {
        r.all = checked;
        r.add = checked;
        r.edit = checked;
        r.archive = checked;
        r.view = checked;
        r.excel = checked;
        r.showMenu = checked;
      } else {
        r[field] = checked;
        r.all = r.add && r.edit && r.archive && r.view && r.excel && r.showMenu;
      }

      if (!r.id) { return; }
      this.firestore.doc(`/${this.env.userPermissions}/${this.selectedRole}/permissions/${r.id}`)
        .set({ ...r }, { merge: true })
        .catch(error => console.error('Error updating permissions:', error));
    });

    console.log(`[toggleGroupColumn] group="${group || 'Ungrouped'}" field="${field}" -> ${checked} (${rows.length} rows)`);
  }

  private setPermissions(data: UserRole[], title: string) {
    this.firestore.collection('user-permissions').doc(title).set({permissions: data}, {merge: true}).then(() => {

    })
  }

  openDialog() {
    const dialogRef = this.dialog.open(AddRolePermissionsComponent, {
      width: '500px',
      height: '300px',
      data: {selectedRole: this.selectedRole}
    });
  }
  selectAllCheckbox() {
    for (const d of this.data) {
      // Set the state of other checkboxes based on the state of "Select All" checkbox

      d.add = d.all;
      d.edit = d.all;
      d.archive = d.all;
      d.view = d.all;
      d.excel = d.all;
      d.showMenu = d.all;
    }

  }
  deletePermission(id: any) {
    if (!confirm('Are you sure you want to delete this permission?')) {
      return;
    }

    // Ensure ID is valid before proceeding
    if (!id) {
      console.error("Invalid ID: Cannot delete");
      return;
    }

    this.firestore
      .collection(this.env.userPermissions)
      .doc(this.selectedRole)
      .collection('permissions')
      .doc(id)
      .delete()
      .then(() => {
        console.log('Permission deleted successfully');
        this.permissionsData = this.permissionsData.filter(d => d.id !== id);

      })
      .catch(error => {
        console.error('Error deleting permission:', error);
      });
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
  trackByFn(index: number, item: any): any {
    return item.id;
  }


  newRoleName = '';
  dialogRef!: MatDialogRef<any>;

  openAddRoleDialog(templateRef: any): void {
    this.newRoleName = ''; // reset
    this.dialogRef = this.dialog.open(templateRef, {
      width: '400px'
    });
  }

  async confirmAddRole(): Promise<void> {
    const roleName = this.newRoleName.trim();
    if (!roleName) return;

    const roleRef = this.firestore.collection(this.env.userPermissions).doc(roleName);

    const doc = await roleRef.get().toPromise();
    if (doc?.exists) {
      alert(`Role "${roleName}" already exists.`);
      return;
    }

    await roleRef.set({ createdAt: new Date() });
    alert(`Role "${roleName}" added successfully!`);
    this.dialogRef.close();
  }
}
